module.exports = __webpack_public_path__ + "static/img/AdamScott.d9282b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AdamScott.jpg
// module id = U6nd
// module chunks = 0